function setDefaultBitteWahlen() {
  document.querySelectorAll("select.select__select").forEach((select) => {
    const bitteWahlenOption = select.querySelector("#bittewahlen");
    if (bitteWahlenOption) {
      bitteWahlenOption.selected = true;
      const changeEvent = new Event("change", { bubbles: true });
      select.dispatchEvent(changeEvent);
    }
  });

  const productFormSubmit = document.querySelector(".product-form__submit");
  if (productFormSubmit) {
    productFormSubmit.disabled = true; 
  }

  const deliveryInfo = document.querySelector(".js-delivery-info");
  if (deliveryInfo) {
    deliveryInfo.style.display = "none";
  }
}

document.addEventListener("DOMContentLoaded", setDefaultBitteWahlen);
